import { typeCoins } from '@shared-logic/prices';
import { WAY_PAY_VOID } from './way-pay.constants';
import { WayPay } from './way-pay.interfaces';
import { Price } from '@shared-logic/prices';
//Esto está mal, estamos importando precios y en precios importamos forma de pago

import { dolarsWithDeposit, dolarsWithDischarge, dolarsWithForward, dolarsWithOutDischarge, pesosWithDeposit, pesosWithDischarge, pesosWithForward, pesosWithOutDischarge, wayPay, wayPayNames } from './way-pay.constants';
import { dateByBusinessDays, getDate, getDateEndOfMonthBusinessDay, getDaysBetweenDatesByBusinessDay } from '@shared-logic/utils';
import { businessDict } from '@shared-logic/business-type';
import { COMMODITIES_CODE } from '@shared-logic/subjects';
import { PRODUCT_NAMES_CONST } from '@shared-logic/products';

export class WayPayValidator {

  constructor() {
  }

  getIBMCode(wayPay: WayPay, typeCoin: string, buyer: number): number {
    return getWayPayCodeIBM(wayPay, typeCoin, buyer);
  }

  /**
   * Returns if the payment method of the condition is cash on delivery
   * @param price 
   * @returns boolean
   */
  getIsContraEntrega(price: Price) {
    return price?.wayPay?.wayPayName == wayPayNames.contraEntrega;
  }

  /**
   * Returns if the payment method of the condition is fixed date
   * @param price 
   * @returns boolean
   */
  getIsFechaFija(price: Price) {
    return price?.wayPay?.wayPayName == wayPayNames.fechaFija;
  }

  /**
   * Returns if the payment method of the condition is Con carta de garantía
   * @param price 
   * @returns boolean
   */
  getIsConCartaDeGarantia(price: Price) {
    return price?.wayPay?.wayPayName == wayPayNames.conCartaGarantia;
  }
}

/**
 * Given the structure of the payment method, it returns what it means in human-understandable text format. 
 * @param wayPayParam 
 * @returns string
 */
export function getWayPayText(wayPayParam: WayPay): string {
  if (!wayPayParam || wayPayParam.wayPayName <= 0) {
    return '--';
  }

  const WAY_PAY: any = wayPay;
  let stringToReturn = WAY_PAY[wayPayParam.wayPayName] || '';

  if (wayPayParam.wayPayName == wayPayNames.conCartaGarantia) {
    stringToReturn += wayPayParam.options == 1 ? ' y certificado de depósito'
      : wayPayParam.options == 2 ? ' y warrant' : '';
  }

  stringToReturn += `\n${getDaysWayPayText(wayPayParam)} - ${getPercentageWayPay(wayPayParam)}`;
  return stringToReturn;
}

/**
 * Given the structure of the payment method, 
 * it returns in human-understandable text format the days it has and whether they are business days or calendar days.
 * @param wayPayParam 
 * @returns string 
 */
export function getDaysWayPayText(wayPayParam: WayPay): string {
  const days = wayPayParam.days;
  const isBusinessDay = wayPayParam.isBusinessDays == 1; //Get if is business days or not
  return days + (days == 1 ? ' día' : ' días') + (isBusinessDay ? ' hábiles' : ' corridos');
}

/**
 * Given the structure of the payment method, it returns the percentage it has and its symbol in human-understandable text format.
 * @param wayPayParam 
 * @returns string
 */
export function getPercentageWayPay(wayPayParam: WayPay): string {
  return wayPayParam.percentage + '%';
}

/**
 * Given a price and a payment method code (wayPayName), perform a validation located at 
 * https://docs.google.com/spreadsheets/d/1o1lC9c9VIid-eXxInv8XYS8H9TYRbXzY76nmqI9P7fk/edit#gid=1213801806 
 * and the function returns a WayPay structure with the values set by Default for that price and that form of payment
 * @param price 
 * @param wayPayName 
 * @returns WayPay 
 */
export function getWayPayDefault(price: Price, wayPayName: number): WayPay {
  try {
    const typeCoin = price.typeCoin;
    const typeBusiness = price.typeBusiness;
    const deliveryPeriod = price.deliveryPeriod;
    let days = 5;
    let newExpiration = '--';

    if (wayPayName == wayPayNames.contraEntrega) {
      //Cuando se entrega la mercadería.
      days = 3;
      newExpiration = '--';//Reseteamos la expiración

    } else if (wayPayName == wayPayNames.conCartaGarantia) {
      if (typeCoin == typeCoins.USD) {
        //Por default 5 días hábiles de la pesificación, no sabemos cuando es la pesificacion, entonces no hay fecha
      } else if (typeCoin == typeCoins.ARS) {
        //Por default 5 días hábiles o corridos del día posterior o sino XX días de selección
        newExpiration = dateByBusinessDays(getDate(), days, true);
      }
    } else if (wayPayName == wayPayNames.fechaFija) {
      if (typeBusiness == businessDict.conDescarga || typeBusiness == businessDict.depositos) {
        newExpiration = dateByBusinessDays(getDate(), days, true);
        //Por default 5 días hábiles o corridos del día posterior o sino se coloca
        //el vencimiento manual - la mercadería tiene que estar entregada para cobrar"
      } else if (typeBusiness == businessDict.sinDescarga) {
        //Se muestra la fecha que ponen manual
      } else if (typeBusiness == businessDict.forward) {
        //Último día hábil del mes de entrega
        newExpiration = getDateEndOfMonthBusinessDay(deliveryPeriod.endDate);
        //days = getDaysBetweenDates(getDate(), newExpiration)
        days = getDaysBetweenDatesByBusinessDay(getDate(), newExpiration, true)

      }
    } else if (wayPayName == wayPayNames.diferidoPesificacion) {
      //newExpiration = dateByBusinessDays(this.date.getDate(), days, true);

      //Por default 5 días hábiles
    } else if (wayPayName == wayPayNames.diferidoFacturacion) {
      days = 10;
      //Por default 10 días hábiles del día posterior o sino XX días de selección
      //newExpiration = dateByBusinessDays(this.date.getDate(), days, true);
    } else if (wayPayName == wayPayNames.contraFixMercaderiaEntregada) {
      //Por default 5 días hábiles, sin fecha de vencimiento
    } else if (wayPayName == wayPayNames.contraFixCartaGarantia) {
      //Por default 5 días hábiles, sin fecha de vencimiento
    }

    return {
      wayPayName: wayPayName,
      percentage: wayPayName <= 0 ? 0 :  //Si NO hay forma de pago, seteamos porcentaje en 0. 
        price.wayPay.percentage > 0 ? price.wayPay.percentage : //Si el porcentaje es mayor a 0, mantenemos el mismo 
          price.productName == PRODUCT_NAMES_CONST.TRIGO ? 95 : 97.5, //Si era trigo, 95%, sino 97.5%
      //Si ya tenía porcentaje de forma de pago, mantenemos el mismo, sino 97.5
      expiration: newExpiration,
      days: days,
      isBusinessDays: 1,
      options: 0
    }
  } catch (error) {
    return WAY_PAY_VOID;
  }
}

/**
 * Given the payment method structure, it returns in date format the expiration date that it should have by default.
 * @param price 
 * @param wayPay 
 * @returns string
 */
export function getExpirationByWayPay(price: Price, wayPay: WayPay): string {
  try {
    const typeCoin = price.typeCoin;
    const typeBusiness = price.typeBusiness;
    const deliveryPeriod = price.deliveryPeriod;
    const wayPayName = wayPay.wayPayName;
    let days = wayPay.days;
    let newExpiration = '--';

    if (wayPayName == wayPayNames.conCartaGarantia && typeCoin == typeCoins.ARS) {
      newExpiration = dateByBusinessDays(getDate(), days, true);
    } else if (wayPayName == wayPayNames.fechaFija) {
      if (typeBusiness == businessDict.conDescarga || typeBusiness == businessDict.depositos) {
        newExpiration = dateByBusinessDays(getDate(), days, true);
      } else if (typeBusiness == businessDict.forward) {
        newExpiration = getDateEndOfMonthBusinessDay(deliveryPeriod.endDate);
      }
    }

    return newExpiration
  } catch (error) {
    return '--';
  }
}

/**
 * Given a payment method, returns if it belongs to a business condition with deferred payment
 * @param wayPayName
 * @returns boolean
 */
export function getIsWayPayDeferred(wayPayName: number) {
  return wayPayName == wayPayNames.diferidoFacturacion || wayPayName == wayPayNames.diferidoPesificacion;
}

/**
 * Given a payment method, returns whether it belongs to a business variant
 * @param wayPayName
 * @returns boolean
 */
export function getIsWayPayVariant(wayPayName: number) {
  return [wayPayNames.contraEntrega, wayPayNames.conCartaGarantia, wayPayNames.fechaFija].includes(wayPayName);
}

/**
 * Given a business condition, returns the valid payment methods for that case.
 * Analyzes the start and end date, if none, returns an empty array.
 * Analyzes the currency, for each case it returns the valid ones depending on the type of business.
 * @param price 
 * @returns number[] 
 */
export function getWayPaysValids(price: Price): number[] {
  if (price.deliveryPeriod.startDate == '--' || price.deliveryPeriod.endDate == '--') {
    return [];
  }

  const businessMapping: { [key: number]: number[] } = {
    1: price.typeCoin === typeCoins.ARS ? pesosWithDischarge : dolarsWithDischarge,
    2: price.typeCoin === typeCoins.ARS ? pesosWithOutDischarge : dolarsWithOutDischarge,
    3: price.typeCoin === typeCoins.ARS ? pesosWithDeposit : dolarsWithDeposit,
    4: price.typeCoin === typeCoins.ARS ? pesosWithForward : dolarsWithForward,
  };

  return businessMapping[price.typeBusiness] || [];
}

/**
 * Given a currency type, returns the possible payment methods that will be used to complete a counterparty.
 * 
 * @param { string } typeCoin - currency type of exchange
 * @returns number[] - Array of possible payment methods
 */
export function getWayPayFromExchange(typeCoin: string): number[] {
  if (typeCoin == typeCoins.ARS) {
    return [wayPayNames.contraEntrega, wayPayNames.conCartaGarantia, wayPayNames.fechaFija, wayPayNames.diferidoFacturacion];
  } else if (typeCoin == typeCoins.USD) {
    return [wayPayNames.contraEntrega, wayPayNames.conCartaGarantia, wayPayNames.diferidoPesificacion];
  } else if (typeCoin == '--') {
    // Exchange of a to-fix mother: no price nor currency yet, so only the to-fix payment methods apply.
    return [wayPayNames.contraFixMercaderiaEntregada, wayPayNames.contraFixCartaGarantia];
  }
  return []
}

/**
 * Given a price, obtain the payment method and analyze which code should reach IBM.
 * Code obtained from CERCPA table.
 * @param wayPay 
 * @param typeCoin 
 * @param buyer
 * @returns number
 * */
export function getWayPayCodeIBM(wayPay: WayPay, typeCoin: string, buyer: number): number {
  const percentage = wayPay.percentage;
  const isDolar: boolean = typeCoin == typeCoins.USD;
  const expiration = wayPay.expiration;
  const wayPayName = wayPay.wayPayName;
  const isBusinessDay: boolean = wayPay.isBusinessDays == 1;
  const options: number = wayPay.options;

  switch (percentage) {
    case 97.5: return get975PercentageWayPay(wayPayName, isBusinessDay, isDolar, expiration, options, buyer);
    case 100: return get100PercentageWayPay(wayPayName, isBusinessDay, isDolar, expiration);
    case 95: return get950PercentageWayPay(wayPayName, isBusinessDay, isDolar, expiration);
    case 98.5: return get985PercentageWayPay(wayPayName, isBusinessDay, isDolar, expiration);
    case 90: return get900PercentageWayPay(wayPayName, isBusinessDay, isDolar, expiration);
    case 85: return get850PercentageWayPay(wayPayName, isBusinessDay, isDolar, expiration);
    case 80: return get800PercentageWayPay(wayPayName, isBusinessDay, isDolar, expiration);
    case 50: return get50PercentageWayPay(wayPayName, isBusinessDay, isDolar, expiration, options, buyer);
  }
  return 0;
}

/**
 * State of a payment method against the IBM payment conditions (CERCPA):
 * - empty: no payment method selected.
 * - valid: the combination has an IBM code.
 * - missingExpiration: the combination exists but needs an expiration date that is not loaded yet.
 * - nonexistent: the loaded combination (method, percentage, days type, currency, options) has no IBM code.
 */
export type WayPayCombinationState = 'empty' | 'valid' | 'missingExpiration' | 'nonexistent';

// Any loaded date: only used to check whether a combination exists once its expiration is filled in.
const EXPIRATION_PLACEHOLDER = '01-01-2099';

/**
 * Classifies a payment method so the form can tell a combination that does not exist in IBM
 * from one that is only waiting for its expiration date.
 * @param wayPay Payment method to check.
 * @param typeCoin Currency of the contract the payment method belongs to.
 * @param buyer Buyer code used by the IBM conversion (Commodities rule).
 * @returns WayPayCombinationState
 */
export function getWayPayCombinationState(wayPay: WayPay | null | undefined, typeCoin: string, buyer: number): WayPayCombinationState {
  if (!wayPay || wayPay.wayPayName <= 0) {
    return 'empty';
  }
  if (getWayPayCodeIBM(wayPay, typeCoin, buyer) > 0) {
    return 'valid';
  }
  const hasExpiration = !!wayPay.expiration && wayPay.expiration != '--';
  if (!hasExpiration && getWayPayCodeIBM({ ...wayPay, expiration: EXPIRATION_PLACEHOLDER }, typeCoin, buyer) > 0) {
    return 'missingExpiration';
  }
  return 'nonexistent';
}

/**
 * Whether the expiration of a payment method matters for IBM: loading it changes the IBM code
 * (for example, fixed date or letter of guarantee with a certain date).
 * @param wayPay Payment method to check.
 * @param typeCoin Currency of the contract the payment method belongs to.
 * @param buyer Buyer code used by the IBM conversion.
 * @returns boolean
 */
export function isWayPayExpirationRelevant(wayPay: WayPay | null | undefined, typeCoin: string, buyer: number): boolean {
  if (!wayPay || wayPay.wayPayName <= 0) {
    return false;
  }
  const withoutExpiration = getWayPayCodeIBM({ ...wayPay, expiration: '--' }, typeCoin, buyer);
  const withExpiration = getWayPayCodeIBM({ ...wayPay, expiration: EXPIRATION_PLACEHOLDER }, typeCoin, buyer);
  return withoutExpiration != withExpiration;
}

/**
 * Whether the payment method cannot convert to an IBM code without an expiration.
 * @param wayPay Payment method to check.
 * @param typeCoin Currency of the contract the payment method belongs to.
 * @param buyer Buyer code used by the IBM conversion.
 * @returns boolean
 */
export function isWayPayExpirationRequired(wayPay: WayPay | null | undefined, typeCoin: string, buyer: number): boolean {
  return isWayPayExpirationRelevant(wayPay, typeCoin, buyer) && getWayPayCodeIBM({ ...wayPay!, expiration: '--' }, typeCoin, buyer) == 0;
}

/* ------------------------------------------ */

/**
 *  The functions 'get100PercentageWayPay', 'get985PercentageWayPay', 'get975PercentageWayPay', 'get950PercentageWayPay', 
 * 'get900PercentageWayPay', 'get850PercentageWayPay' and 'get800PercentageWayPay' 
 * are passed as a parameter to our payment method, if isBusinessDay, if isDolar, 
 * and the expiration and after doing a series of calculations to analyze what the number is for IBM, it returns it.
 * */

function get100PercentageWayPay(wayPayName: number, isBusinessDay: boolean, isDolar: boolean, expiration: string): number {
  if (wayPayNames.contraEntrega == wayPayName) { //Contra entrega solo es con dias habiles
    if (isBusinessDay) {
      //Si es en dolares, es siempre la misma
      return isDolar ? 15 : 15;
    }
  } else if (wayPayNames.conCartaGarantia == wayPayName) { //Con carta de garantía solo con días hábiles.
    if (isBusinessDay) {
      if (expiration && expiration != '--') { //Si tiene vencimiento significa que es una fecha cierta
        return 19;
      }
    }
  } else if (wayPayNames.fechaFija == wayPayName) { //Fecha fija es solo en pesos
    if (!isDolar && expiration && expiration != '--') { //Si tiene vencimiento significa que es una fecha cierta
      //Si es día hábil o no, es siempre el mismo código.
      return isBusinessDay ? 1 : 1;
    }
  } else if (wayPayNames.diferidoFacturacion == wayPayName) { //Diferido de la facturacion es siempre en pesos
    if (!isDolar && isBusinessDay) {
      return 7;
    } else if (!isDolar && !isBusinessDay) {
      return 57;
    }
  } else if (wayPayNames.diferidoPesificacion == wayPayName) { //Diferido de la pesificacion es siempre en dolares
    if (isDolar && isBusinessDay) {
      return 10;
    }
  } else if (wayPayNames.contraFixMercaderiaEntregada == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR
    return isBusinessDay ? 28 : 49;
  } else if (wayPayNames.contraFixCartaGarantia == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR

  }
  return 0;
}

function get985PercentageWayPay(wayPayName: number, isBusinessDay: boolean, isDolar: boolean, expiration: string): number {
  if (wayPayNames.contraEntrega == wayPayName) { //Contra entrega solo es con dias habiles


  } else if (wayPayNames.conCartaGarantia == wayPayName) { //Con carta de garantía solo con días hábiles.


  } else if (wayPayNames.fechaFija == wayPayName) { //Fecha fija es solo en pesos
    if (!isDolar && expiration && expiration != '--') { //Si tiene vencimiento significa que es una fecha cierta
      //Si es día hábil o no, es siempre el mismo código.
      return isBusinessDay ? 9 : 9;
    }
  } else if (wayPayNames.diferidoFacturacion == wayPayName) { //Diferido de la facturacion es siempre en pesos
    if (!isDolar && isBusinessDay) {
      return 41;
    }
  } else if (wayPayNames.diferidoPesificacion == wayPayName) { //Diferido de la pesificacion es siempre en dolares


  } else if (wayPayNames.contraFixMercaderiaEntregada == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR
    return !isBusinessDay ? 32 : 0;
  } else if (wayPayNames.contraFixCartaGarantia == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR

  }
  return 0;
}

function get975PercentageWayPay(wayPayName: number, isBusinessDay: boolean, isDolar: boolean, expiration: string, options: number, buyer: number): number {
  if (wayPayNames.contraEntrega == wayPayName) { //Contra entrega solo es con dias habiles
    if (isBusinessDay) {
      //Si es en dolares, es siempre la misma
      return isDolar ? 212 : 212;
    }
  } else if (wayPayNames.conCartaGarantia == wayPayName) { //Con carta de garantía solo con días hábiles.
    //Si tiene marcado opciones, entonces es con Warrant o certificado de depósito
    if (options > 0) {
      if (options == 1) {
        return 216; //Certificado de depósito
      } else if (options == 2) {
        return 230; //Warrant
      }
    }

    if (isBusinessDay) {
      if (!isDolar && expiration && expiration != '--') { //Si tiene vencimiento significa que es una fecha cierta
        return 215;
      } else if (isDolar) { //Si es en dolares, y no tiene fecha cierta, es siempre 398

        //Si es Commodities, entonces es 398
        if (COMMODITIES_CODE == buyer) {
          return 398;
        }

        return (expiration && expiration != '--') ? 215 : 398;
      }
    }
  } else if (wayPayNames.fechaFija == wayPayName) { //Fecha fija es solo en pesos
    if (!isDolar && expiration && expiration != '--') { //Si tiene vencimiento significa que es una fecha cierta
      //Si es día hábil o no, es siempre el mismo código.
      return isBusinessDay ? 213 : 213;
    }
  } else if (wayPayNames.diferidoFacturacion == wayPayName) { //Diferido de la facturacion es siempre en pesos
    if (!isDolar) {
      //Si es día hábil, es un código, sino es otro
      return isBusinessDay ? 95 : 555;
    }
  } else if (wayPayNames.diferidoPesificacion == wayPayName) { //Diferido de la pesificacion es siempre en dolares
    if (isDolar) {
      //Si es día hábil, es un código, sino es otro
      return isBusinessDay ? 298 : 296;
    }
  } else if (wayPayNames.contraFixMercaderiaEntregada == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR
    return isBusinessDay ? 218 : 222;
  } else if (wayPayNames.contraFixCartaGarantia == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR
    return isBusinessDay ? 264 : 0;
  }
  return 0;
}

function get950PercentageWayPay(wayPayName: number, isBusinessDay: boolean, isDolar: boolean, expiration: string): number {
  if (wayPayNames.contraEntrega == wayPayName) { //Contra entrega solo es con dias habiles
    if (isBusinessDay) {
      //Si es en dolares, es siempre la misma
      return isDolar ? 117 : 117;
    }
  } else if (wayPayNames.conCartaGarantia == wayPayName) { //Con carta de garantía solo con días hábiles.

    if (!isDolar) {
      if (expiration && expiration != '--') { //Si tiene vencimiento significa que es una fecha cierta
        return isBusinessDay ? 422 : 422; //Con fecha cierta
      }
    } else {
      //Si tiene vencimiento significa 
      return isBusinessDay ? 344 : 0;
    }

  } else if (wayPayNames.fechaFija == wayPayName) { //Fecha fija es solo en pesos
    if (!isDolar && expiration && expiration != '--') { //Si tiene vencimiento significa que es una fecha cierta
      //Si es día hábil o no, es siempre el mismo código.
      return isBusinessDay ? 421 : 421;
    }
  } else if (wayPayNames.diferidoFacturacion == wayPayName) { //Diferido de la facturacion es siempre en pesos

    if (!isDolar) {
      //Si es día hábil, es un código, sino es otro
      return isBusinessDay ? 429 : 0;
    }

  } else if (wayPayNames.diferidoPesificacion == wayPayName) { //Diferido de la pesificacion es siempre en dolares
    if (isDolar) {
      //Si es día hábil, es un código, sino es otro
      return isBusinessDay ? 322 : 0;
    }
  } else if (wayPayNames.contraFixMercaderiaEntregada == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR
    if (isBusinessDay) {
      return 118;
    }
  } else if (wayPayNames.contraFixCartaGarantia == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR
    if (isBusinessDay) {
      return 0;
    }
  }
  return 0;
}

function get900PercentageWayPay(wayPayName: number, isBusinessDay: boolean, isDolar: boolean, expiration: string): number {
  if (wayPayNames.contraEntrega == wayPayName) { //Contra entrega solo es con dias habiles
    if (isBusinessDay) {
      //Si es en dolares, es siempre la misma
      return isDolar ? 101 : 101;
    }
  } else if (wayPayNames.conCartaGarantia == wayPayName) {

    // Día habil o dia corrido: Carta de garantía al 90: 200 en pesos 
    // Día habil: 498 sin fecha en dólares
    if (isBusinessDay) {
      if (!isDolar) { //Si tiene vencimiento significa que es una fecha cierta
        return isBusinessDay ? 200 : 200;
      } else if (isDolar) { //Si es en dolares, y no tiene fecha cierta, es siempre 498
        return isBusinessDay ? 498 : 0;
      }
    }

  } else if (wayPayNames.fechaFija == wayPayName) {


    // Día habil o dia corrido: al 90: en pesos: 554
    // 0 en dólares
    if (isBusinessDay) {
      if (!isDolar) { //Si tiene vencimiento significa que es una fecha cierta
        return isBusinessDay ? 554 : 554;
      } else if (isDolar) { //Si es en dolares, y no tiene fecha cierta, es siempre 498
        return 0;
      }
    }


  } else if (wayPayNames.diferidoFacturacion == wayPayName) {
    if (!isDolar) {
      //Si es día hábil, es un código, sino es otro
      return isBusinessDay ? 128 : 54;
    }
  } else if (wayPayNames.diferidoPesificacion == wayPayName) {

    if (isDolar) {
      //Si es día hábil, es un código, sino es otro
      return isBusinessDay ? 11 : 56;
    }

  } else if (wayPayNames.contraFixMercaderiaEntregada == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR

    return isBusinessDay ? 102 : 40;

  } else if (wayPayNames.contraFixCartaGarantia == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR

    return isBusinessDay ? 55 : 0;
  }
  return 0;
}

function get850PercentageWayPay(wayPayName: number, isBusinessDay: boolean, isDolar: boolean, expiration: string): number {
  if (wayPayNames.contraEntrega == wayPayName) { //Contra entrega solo es con dias habiles

  } else if (wayPayNames.conCartaGarantia == wayPayName) {

  } else if (wayPayNames.fechaFija == wayPayName) {

  } else if (wayPayNames.diferidoFacturacion == wayPayName) {

  } else if (wayPayNames.diferidoPesificacion == wayPayName) {

  } else if (wayPayNames.contraFixMercaderiaEntregada == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR
    return isBusinessDay ? 557 : 0;
  } else if (wayPayNames.contraFixCartaGarantia == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR

  }
  return 0;
}

function get800PercentageWayPay(wayPayName: number, isBusinessDay: boolean, isDolar: boolean, expiration: string): number {
  if (wayPayNames.contraEntrega == wayPayName) { //Contra entrega solo es con dias habiles
    if (isBusinessDay) {
      //Si es en dolares, es siempre la misma
      return isDolar ? 888 : 888;
    }
  } else if (wayPayNames.conCartaGarantia == wayPayName) {



  } else if (wayPayNames.fechaFija == wayPayName) {



  } else if (wayPayNames.diferidoFacturacion == wayPayName) {



  } else if (wayPayNames.diferidoPesificacion == wayPayName) {


  } else if (wayPayNames.contraFixMercaderiaEntregada == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR
    if (isBusinessDay) {
      return 0;
    }
  } else if (wayPayNames.contraFixCartaGarantia == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR
    if (isBusinessDay) {
      return 0;
    }
  }
  return 0;
}

function get50PercentageWayPay(wayPayName: number, isBusinessDay: boolean, isDolar: boolean, expiration: string, options: number, buyer: number): number {
  if (wayPayNames.contraEntrega == wayPayName) { //Contra entrega al 50% (pesos y dólares)
    if (isBusinessDay) {
      return 191;
    }
  } else if (wayPayNames.conCartaGarantia == wayPayName) { //Carta de garantía al 50% - requiere fecha cierta
    // Solo retorna 194 si tiene fecha de expiración cierta (no importa moneda)
    if (expiration && expiration != '--') {
      return 194;
    }
  } else if (wayPayNames.fechaFija == wayPayName) { //Fecha fija no aplica al 50%
    return 0;
  } else if (wayPayNames.diferidoFacturacion == wayPayName) { //Diferido de la facturación al 50% (pesos por regla de negocio)
    if (!isDolar) {
      //Si es día hábil, es código 192
      return isBusinessDay ? 192 : 0;
    }
  } else if (wayPayNames.diferidoPesificacion == wayPayName) { //Diferido de la pesificación al 50% (dólares por regla de negocio)
    if (isDolar) {
      //Si es día hábil, es código 193
      return isBusinessDay ? 193 : 0;
    }
  } else if (wayPayNames.contraFixMercaderiaEntregada == wayPayName) { //Contra fijación mercadería entregada al 50%
    return 195;
  } else if (wayPayNames.contraFixCartaGarantia == wayPayName) { //Contra fix mercaderia entregada de condición A FIJAR
    return 0;
  }
  return 0;
}

/* ------------------------------------------ */

/**
 * Given an IBM code with a number of days, create a WayPay structure according to the ones we use in the system.
 * Follow the following logic:
 * If you do not have a proforma: auto-complete it as the parent contract.
 * If you have a proforma and the parent contract is with a letter of guarantee: automatically suggest a guarantee with the percentage of the payment method of the proforma.
 * If you have a proforma: auto-complete it with the proforma and the possibility of editing it.
 * @param code 
 * @param days
 * @returns WayPay
 * */
export function getWayPayStruct(code: number, days: number, wayPayMother: WayPay): WayPay {
  //If you do not have a proforma: auto-complete it as the parent contract.
  if (code <= 0) {
    return wayPayMother;
  }


  let wayPay: WayPay = JSON.parse(JSON.stringify(WAY_PAY_VOID));

  //If you have a proforma and the parent contract is with a letter of guarantee: automatically suggest a guarantee with the percentage of the payment method of the proforma.
  wayPay.wayPayName = (wayPayMother.wayPayName == wayPayNames.conCartaGarantia) ? wayPayNames.conCartaGarantia : wayPayNames.contraEntrega

  /*Si el negocio es con carta de garantía, autocompleta con el porcentaje que trae la proforma.
    Pero en la mayoría de casos la proforma trae 3 días (del contra entrega).
    ¿Debe quedarse los 3 días o cambiar al valor del madre si es con carta de garantía?
    ¿Debe quedarse si son días habiles o cambiar al valor del madre?
    ¿Qué pasa con la fecha de vencimiento de la parcial?*/

  wayPay.days = days == 0 ? 3 : days;
  wayPay.expiration = '--';
  wayPay.isBusinessDays = 1;
  wayPay.percentage = getPercentageByCode(code);

  return wayPay;
}

function getPercentageByCode(code: number) {
  switch (code) {
    case 212: return 97.5;
    case 15: return 100;
    case 117: return 95;
  }
  return 0;
}